import { Component, OnInit, Renderer2, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink, Router } from '@angular/router';
import validateForm from '../../helpers/validateform';

import { EncryptionService } from '../../services/encryption.service';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { TimesheetService } from '../../services/timesheet.service';
import { MaintenanceService, LoginMaintenanceStatus, LoginNoticeItem } from '../../services/maintenance.service';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
// 
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
  
export class LoginComponent {
  title = 'login';
  isTestPeriod = environment.isTestPeriod;
  loginForm!: FormGroup;
  submitted = false;
  errorMessage: string = '';
  successMessage: string = '';
  logInMsg: any;
  isText: boolean = false;
  eyeIcon: string = "bi-eye-slash";
  type: string = "password";
  isSelected: any;
  buttonText: any;
  lang: any;
  termsAgreed: any;
  privecy: any;
  loginId: string = '';
  password: string = '';

  // メンテナンス状態
  isSuspended: boolean = false;
  public adminBypassMode: boolean = false;
  suspendStartDate: string = '';
  suspendEndDate: string = '';
  notices: LoginNoticeItem[] = [];
  
  // キーボードイベントリスナーを追加して、管理者バイパスモードを有効化
  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (this.isSuspended && event.key === '*') {
      this.adminBypassMode = true;
    }
  }

  constructor(private formBuilder: FormBuilder, private auth: AuthService, private router: Router,private translate: TranslateService, private user: UserService, private en: EncryptionService, private renderer: Renderer2, private ts: TimesheetService, private maintenanceSvc: MaintenanceService) { 

    // console.log('hi');
   translate.addLangs(['en', 'jp']);
    // translate.setDefaultLang('en');
    // translate.use('en');

    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang')?localStorage.getItem('site_lang'): 'jp');
      // console.log(this.lang)
      localStorage.setItem('site_lang', this.lang);
      translate.use(this.lang);
    }
  }
  
  switchLanguage(lang: string) {
    // console.log(lang);
    this.isSelected = lang;
    this.lang = lang;
    if (lang == 'en') {
      this.buttonText = 'English';
      this.renderer.removeClass(document.body, 'body-jp-class');
    } else if (lang == 'jp') {
      this.buttonText = 'Japanese';
      this.renderer.addClass(document.body, 'body-jp-class');
    }
    localStorage.setItem('site_lang', lang);
    // console.log(localStorage.getItem('site_lang'));
    this.translate.use(lang);
  }
  
  ngOnInit(): void {
    console.log('🚀 Login component initialized');
    console.time('⏱️ Total ngOnInit');
    
    // redirect to home if already logged in
    // if (this.authService.currentUserValue) {
    //   this.router.navigate(['/']);
    // }
    if (this.lang == 'en') {
      this.buttonText = 'English';
      this.isSelected = 'en';
    } else if (this.lang == 'jp') {
      this.buttonText = 'Japanese';
      this.isSelected = 'jp';
    }
    this.logInMsg = 'Log In to Your Account';
    this.loginForm = this.formBuilder.group({
      loginID: ['', Validators.required],
      password: ['', Validators.required]
    });

    // メンテナンス状態を取得
    this.maintenanceSvc.getLoginMaintenanceStatus().subscribe(status => {
      this.isSuspended = status.isSuspended;
      this.notices = status.notices;
      if (status.isSuspended) {
        this.suspendStartDate = this.formatDateTime(status.suspendStartDate);
        this.suspendEndDate   = this.formatDateTime(status.suspendEndDate);
      }
    });

    console.timeEnd('⏱️ Total ngOnInit');
  }
  get f() { return this.loginForm.controls; }

  // 日時を yyyy/M/d HH:mm（24時間）形式にフォーマット
  formatDateTime(dateStr: string | null | undefined): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  // 告知テキスト内のリンククリックを処理（Angular Routerに横取りさせない）
  onNoticeClick(event: MouseEvent): void {
    const anchor = (event.target as HTMLElement).closest('a');
    if (!anchor) return;
    const href = anchor.getAttribute('href');
    if (!href) return;
    // 絶対URL・mailto は通常通りブラウザが処理
    if (href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('//')) return;
    // 相対URLはAngular Routerに渡さず直接開く
    event.preventDefault();
    event.stopPropagation();
    window.open(href, anchor.getAttribute('target') || '_blank');
  }

  hideShowPass() {    
      this.isText = !this.isText;
      this.isText ? this.eyeIcon = "bi-eye" : this.eyeIcon = "bi-eye-slash";
      this.isText ? this.type = "text" : this.type = "password";
  }

  goToForgotPassword(): void {
    this.router.navigate(['/forgot-password'], {
      state: { fromLogin: true }
    });
  }

  login(): void {
    console.log('🔑 Login process started');
    console.time('⏱️ Total Login Process');
    console.time('⏱️ Validation and Encryption');
    
    // console.log(this.loginForm.value.password);
    this.submitted = true;
    
    // Clear any existing tokens before login attempt
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      localStorage.removeItem('token');
    }
    
    const asciiRegex = /^[\x00-\x7F]+$/;
    if (this.loginForm.invalid) {
      validateForm.validateAllFormFields(this.loginForm);
      alert(this.translate.instant('PleaseFillFormCorrectly'));     
      return;
    } else {
      if (!asciiRegex.test(this.loginForm.value.loginID)) {
        let alertMsg = `${this.translate.instant('InvalidUserId')}`
        alert(alertMsg);
        this.loginForm.patchValue({ loginID: '' });
        return;
      } 
    }
    // this.loginForm.value.password = this.en.encryptUsingAES256(this.loginForm.value.password);
    this.loginId = this.loginForm.value.loginID;
    this.password = this.loginForm.value.password;
    this.loginForm.value.password = this.en.encryptUsingAES256(this.loginForm.value.password);
    
    console.timeEnd('⏱️ Validation and Encryption');

    // Choose endpoint based on environment configuration
    const useNewEndpoint = environment.useNewLoginEndpoint;
    console.log(`🔧 Using ${useNewEndpoint ? 'NEW' : 'OLD'} login endpoint`);

    if (useNewEndpoint) {
      // ========================================
      // NEW ENDPOINT: authenticate-with-profile
      // Single API call with user profile included
      // ========================================
      console.time('⏱️ API Call: auth.loginWithProfile');
      
      this.auth.loginWithProfile(this.loginForm.value, this.lang).subscribe({
        next: (res: any) => {
          console.timeEnd('⏱️ API Call: auth.loginWithProfile');
          console.log('📊 Login with profile API response received');
          
          if (res.status) {
            console.log('✅ Authentication successful with profile, storing data...');
            console.time('⏱️ Store user data and navigation');
            
            // Store token
            this.auth.storeToken(res.data.token);
            this.errorMessage = '';
            this.successMessage = res.message;
            this.loginForm.reset();

            // パスワード有効期限日を保存
            if (res.data?.passwordExpiryDate) {
              const d = new Date(res.data.passwordExpiryDate);
              const formatted = `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
              this.auth.storePasswordExpiryDate(formatted);
            } else {
              this.auth.storePasswordExpiryDate(null);
            }

            // Store user profile data (received in same response)
            const userData = res.data.user;
            this.auth.storeCode(userData.userCode);
            this.auth.storeName(userData.userName);
            this.auth.storeLoginId(userData.loginId);
            this.auth.storeRole(userData.userRole);
            this.auth.storeType(userData.userType);
            this.auth.storeAdminLevel(userData.adminLevel);
            this.auth.storeReadWrite(userData.readWrite);
            this.auth.storeRepId(userData.repId ?? '');
            this.auth.storeEmail(userData.email2);
            this.auth.storeCompanyName(userData.companyName);
            
            console.log('📄 User data stored:', {
              userCode: userData.userCode,
              userName: userData.userName,
              userRole: userData.userRole,
              userType: userData.userType
            });
            
            // UserIDを保存
            if (userData.userId !== undefined && userData.userId !== null) {
              this.auth.storeUserId(userData.userId);
            } else if (userData.userID !== undefined && userData.userID !== null) {
              this.auth.storeUserId(userData.userID);
            }
            
            if (userData.noticeEmail) {
              this.termsAgreed = 'yes';
            } else {
              this.termsAgreed = 'no';
            }
            
            if (userData.privacy) {
              this.privecy = 'yes';
            } else {
              this.privecy = 'no';
            }
            this.auth.storeNotice(this.termsAgreed);
            this.auth.storePrivecy(this.privecy);

            // パスワード有効期限残り日数チェック（通常ログインのみ）
            if (res.data?.passwordExpiryDays !== null && res.data?.passwordExpiryDays !== undefined) {
              if (res.data.passwordExpiryDays <= 0) {
                // 残り0日（当日期限）→ パスワード変更画面へ強制誘導
                alert(this.translate.instant('PasswordExpiryWarningToday'));
                this.router.navigate(['first-reset-password'], { state: { loginId: this.loginId, password: this.password, isExpired: true } });
                return;
              } else if (res.data.passwordExpiryDays <= 7) {
                alert(this.translate.instant('PasswordExpiryWarning', { days: res.data.passwordExpiryDays }));
              }
            }

            console.log('🧭 Privacy consent:', this.privecy);
            console.log('🎯 Navigating to:', userData.userRole);
            
            // Navigate based on privacy and role
            if (this.privecy == "yes") {
              // Prefetch: ホーム画面の月リスト取得をナビゲーション前に開始（shareReplay キャッシュに乗る）
              this.ts.getMonthListV2().subscribe();

              if (userData.userRole == 'Client') {
                console.timeEnd('⏱️ Store user data and navigation');
                console.timeEnd('⏱️ Total Login Process');
                console.log('🎉 Login completed successfully! Navigating to client-associatelist');
                this.router.navigate(['client-associatelist'], { state: { consent: this.termsAgreed } });
                return;
              } else if(userData.userRole == 'Staff') {
                console.timeEnd('⏱️ Store user data and navigation');
                console.timeEnd('⏱️ Total Login Process');
                console.log('🎉 Login completed successfully! Navigating to home');
                this.router.navigate(['home'], { state: { consent: this.termsAgreed } });
                return;
              }
              if (userData.userRole == 'Admin' || userData.userRole == 'Rep') {
                if (userData.userType == 'C') {
                  console.timeEnd('⏱️ Store user data and navigation');
                  console.timeEnd('⏱️ Total Login Process');
                  if (userData.userRole == 'Admin') {
                    console.log('🎉 Login completed successfully! Navigating to admin-home');
                    this.router.navigate(['admin-home']);
                  } else {
                    console.log('🎉 Login completed successfully! Navigating to representative-home');
                    this.router.navigate(['representative-home']);
                  }
                  return;
                } else if (userData.userType == 'B' || userData.userType == 'D') {
                  console.timeEnd('⏱️ Store user data and navigation');
                  console.timeEnd('⏱️ Total Login Process');
                  console.log('🎉 Login completed successfully! Navigating to client-associatelist');
                  this.router.navigate(['client-associatelist']);
                } else if (userData.userType == 'A') {
                  console.timeEnd('⏱️ Store user data and navigation');
                  console.timeEnd('⏱️ Total Login Process');
                  console.log('🎉 Login completed successfully! Navigating to asc-report');
                  this.router.navigate(['asc-report']);
                }
                return;
              } else if (userData.userRole == 'Manager') {
                console.timeEnd('⏱️ Store user data and navigation');
                console.timeEnd('⏱️ Total Login Process');
                console.log('🎉 Login completed successfully! Navigating to manager-home');
                this.router.navigate(['manager-home']);
                return;
              }
            } else {
              console.timeEnd('⏱️ Store user data and navigation');
              console.timeEnd('⏱️ Total Login Process');
              console.log('⚠️ Privacy not agreed, navigating to privacy page');
              this.router.navigate(['privacy']);
            }
          } else {
            console.timeEnd('⏱️ API Call: auth.loginWithProfile');
            console.timeEnd('⏱️ Total Login Process');
            console.log('⚠️ Authentication failed or password change required');
            
            if (res.data?.isAuthenticated && res.data?.mustChangePassword) {
              this.router.navigate(['first-reset-password'], { state: { loginId: this.loginId, password: this.password} });
              return;
            } else if (res.data?.passwordExpired) {
              alert(this.translate.instant('PasswordExpired'));
              this.router.navigate(['first-reset-password'], { state: { loginId: this.loginId, password: this.password, isExpired: true } });
              return;
            } else {
              this.errorMessage = res.message;
              alert(res.message);
              this.loginForm.patchValue({ password: '' });
              this.router.navigate(['login']);
            }
          }
          this.submitted = false;
        },
        error: (err) => {
          console.timeEnd('⏱️ API Call: auth.loginWithProfile');
          console.timeEnd('⏱️ Total Login Process');
          const errorMsg = err?.error?.message || err?.message || 'ログインに失敗しました。IDとパスワードを確認してください。';
          console.error('❌ Login Error:', err);
          alert(errorMsg);
          this.successMessage = '';
          this.errorMessage = errorMsg;
        }
      });
    } else {
      // ========================================
      // OLD ENDPOINT: authenticate + getUserProfile
      // Two sequential API calls (backward compatibility)
      // ========================================
      console.time('⏱️ API Call: auth.login');
      
      this.auth.login(this.loginForm.value, this.lang).subscribe({
        next: (res:any) => {
          console.timeEnd('⏱️ API Call: auth.login');
          console.log('📊 Login API response received');
          
          if (res.status) {
            console.log('✅ Authentication successful, storing token...');
            this.auth.storeToken(res.data.token);
            this.errorMessage = '';
            this.successMessage = res.message;
            this.loginForm.reset();

            // パスワード有効期限日を保存
            if (res.data?.passwordExpiryDate) {
              const d = new Date(res.data.passwordExpiryDate);
              const formatted = `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
              this.auth.storePasswordExpiryDate(formatted);
            } else {
              this.auth.storePasswordExpiryDate(null);
            }

            // パスワード有効期限残り日数を保存（getUserProfile後のナビゲーション前に使用）
            const passwordExpiryDays = res.data?.passwordExpiryDays;

            console.time('⏱️ API Call: getUserProfile');
            // Get user profile data
            this.user.getUserProfile().subscribe({
              next: (res: any) => {
                console.timeEnd('⏱️ API Call: getUserProfile');
                console.log('📊 User profile received');
                
                if (res.status) {
                  console.time('⏱️ Store user data and navigation');
                  
                  this.auth.storeCode(res.data.userCode);
                  this.auth.storeName(res.data.userName);
                  this.auth.storeLoginId(res.data.loginId);
                  this.auth.storeRole(res.data.userRole);
                  this.auth.storeType(res.data.userType);
                  this.auth.storeAdminLevel(res.data.adminLevel);
                  this.auth.storeReadWrite(res.data.readWrite);
                  this.auth.storeEmail(res.data.email2);
                  this.auth.storeCompanyName(res.data.companyName);
                
                console.log('📄 User data stored:', {
                  userCode: res.data.userCode,
                  userName: res.data.userName,
                  userRole: res.data.userRole,
                  userType: res.data.userType
                });
                // UserIDを保存 (2026/01/06追加)
                // バックエンドレスポンスにuserIdまたはuserIDがある場合のみ保存
                if (res.data.userId !== undefined && res.data.userId !== null) {
                  this.auth.storeUserId(res.data.userId);
                } else if (res.data.userID !== undefined && res.data.userID !== null) {
                  this.auth.storeUserId(res.data.userID);
                }
                if (res.data.noticeEmail) {
                  this.termsAgreed = 'yes';
                } else {
                  this.termsAgreed = 'no';
                }
                
                if (res.data.privacy) {
                  this.privecy = 'yes';
                } else {
                  this.privecy = 'no';
                }
                this.auth.storeNotice(this.termsAgreed);
                this.auth.storePrivecy(this.privecy);
                // console.log(res.data.userRole);

                // パスワード有効期限残り日数チェック（通常ログインのみ）
                if (passwordExpiryDays !== null && passwordExpiryDays !== undefined) {
                  if (passwordExpiryDays <= 0) {
                    // 残り0日（当日期限）→ パスワード変更画面へ強制誘導
                    alert(this.translate.instant('PasswordExpiryWarningToday'));
                    this.router.navigate(['first-reset-password'], { state: { loginId: this.loginId, password: this.password, isExpired: true } });
                    return;
                  } else if (passwordExpiryDays <= 7) {
                    alert(this.translate.instant('PasswordExpiryWarning', { days: passwordExpiryDays }));
                  }
                }

                console.log('🧭 Privacy consent:', this.privecy);
                console.log('🎯 Navigating to:', res.data.userRole);
                
                if (this.privecy == "yes") {                  
                  if (res.data.userRole == 'Client') {
                    console.timeEnd('⏱️ Store user data and navigation');
                    console.timeEnd('⏱️ Total Login Process');
                    console.log('🎉 Login completed successfully! Navigating to client-associatelist');
                    this.router.navigate(['client-associatelist'], { state: { consent: this.termsAgreed } });
                    return;
                  } else if(res.data.userRole == 'Staff') {
                    console.timeEnd('⏱️ Store user data and navigation');
                    console.timeEnd('⏱️ Total Login Process');
                    console.log('🎉 Login completed successfully! Navigating to home');
                    this.router.navigate(['home'], { state: { consent: this.termsAgreed } });
                    return;
                  }
                  if (res.data.userRole == 'Admin' || res.data.userRole == 'Rep') {                    
                    // this.router.navigate(['admin-home']);
                    if (res.data.userType == 'C') {
                      console.timeEnd('⏱️ Store user data and navigation');
                      console.timeEnd('⏱️ Total Login Process');
                      if (res.data.userRole == 'Admin') {
                        console.log('🎉 Login completed successfully! Navigating to admin-home');
                        this.router.navigate(['admin-home']);
                      } else {
                        console.log('🎉 Login completed successfully! Navigating to representative-home');
                        this.router.navigate(['representative-home']);
                      }
                      return; // ← 追加: 次の分岐に進まないようにする
                    } else if (res.data.userType == 'B' || res.data.userType == 'D') {
                      console.timeEnd('⏱️ Store user data and navigation');
                      console.timeEnd('⏱️ Total Login Process');
                      console.log('🎉 Login completed successfully! Navigating to client-associatelist');
                      this.router.navigate(['client-associatelist']);
                    } else if (res.data.userType == 'A') {
                      console.timeEnd('⏱️ Store user data and navigation');
                      console.timeEnd('⏱️ Total Login Process');
                      console.log('🎉 Login completed successfully! Navigating to asc-report');
                      this.router.navigate(['asc-report']);
                    }
                    return;
                  }
                  // else if (res.data.userRole == 'Rep') {
                  //   // this.router.navigate(['administrator-menu']);
                  //   if (res.data.userType == 'C') {
                  //     this.router.navigate(['representative-home']);
                  //   } else if (res.data.userType == 'B' || res.data.userType == 'D') {
                  //     this.router.navigate(['client-associatelist']);
                  //   } else if (res.data.userType == 'A') {
                  //     this.router.navigate(['asc-report']);
                  //   }
                  //   return;
                  // }
                  else if (res.data.userRole == 'Manager') {
                    console.timeEnd('⏱️ Store user data and navigation');
                    console.timeEnd('⏱️ Total Login Process');
                    console.log('🎉 Login completed successfully! Navigating to manager-home');
                    // this.router.navigate(['administrator-menu']);
                    this.router.navigate(['manager-home']);
                    return;
                  }
                  // else if (res.data.userRole == 'Admin' || res.data.userRole == 'Rep' || res.data.userRole == 'Manager') {
                  //   // UserType に応じて初期画面を決定
                  //   if (res.data.userType == 'C') {
                  //     this.router.navigate(['manager-home']);
                  //   } else if (res.data.userType == 'B' || res.data.userType == 'D') {
                  //     this.router.navigate(['client-associatelist']);
                  //   } else if (res.data.userType == 'A') {
                  //     this.router.navigate(['asc-report']);
                  //   }
                  //   return;
                  // }
                } else {
                  console.timeEnd('⏱️ Store user data and navigation');
                  console.timeEnd('⏱️ Total Login Process');
                  console.log('⚠️ Privacy not agreed, navigating to privacy page');
                  this.router.navigate(['privacy']);
                }


                // console.log(this.termsAgreed);
                // this.auth.storeConsent(this.termsAgreed);
              } else {
                console.timeEnd('⏱️ API Call: getUserProfile');
                console.timeEnd('⏱️ Total Login Process');
                console.error('❌ User profile fetch failed:', res.message);
                console.log(res.message);
                alert(res.message);
                
              }
            },
            error: (err: any) => {
              console.timeEnd('⏱️ API Call: getUserProfile');
              console.timeEnd('⏱️ Total Login Process');
              const errorMsg = err?.error?.message || err?.message || 'ユーザー情報の取得に失敗しました。';
              console.error('❌ Get User Profile Error:', err);
              alert(errorMsg);
              this.successMessage = '';
              this.errorMessage = errorMsg;
            }
          });

        } else {
          console.timeEnd('⏱️ API Call: auth.login');
          console.timeEnd('⏱️ Total Login Process');
          console.log('⚠️ Authentication failed or password change required');
          
          if (res.data?.isAuthenticated && res.data?.mustChangePassword) {
            // alert("redirect")
            this.router.navigate(['first-reset-password'], { state: { loginId: this.loginId, password: this.password} });
            return;
          } else if (res.data?.passwordExpired) {
            alert(this.translate.instant('PasswordExpired'));
            this.router.navigate(['first-reset-password'], { state: { loginId: this.loginId, password: this.password, isExpired: true } });
            return;
          } else {

            this.errorMessage = res.message;
            alert(res.message);
            this.loginForm.patchValue({ password: '' });
            // console.log(res.message);
            
            this.router.navigate(['login']);
          }
        }
        this.submitted = false;
        // this.auth.storeName(res.data.Profile.FirstName + ' '+ res.data.Profile.LastName);
      },
      error: (err) => {
        console.timeEnd('⏱️ API Call: auth.login');
        console.timeEnd('⏱️ Total Login Process');
        const errorMsg = err?.error?.message || err?.message || 'ログインに失敗しました。IDとパスワードを確認してください。';
        console.error('❌ Login Error:', err);
        alert(errorMsg);
        this.successMessage = '';
        this.errorMessage = errorMsg;
      }
    });
    }
  }
}
